var _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#228B22"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6147 49.3573C62.7735 45.3873 64 40.8369 64 36C64 20.536 51.464 8 36 8C20.536 8 8 20.536 8 36C8 51.464 20.536 64 36 64C40.6539 64 45.0426 62.8646 48.9043 60.8557C56.8199 62.4685 65.8326 63.1017 71.0866 59.9834C67.0348 58.4872 62.6351 53.678 60.6147 49.3573Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.6147 49.3573L59.7362 48.8796L59.4948 49.3233L59.7088 49.7809L60.6147 49.3573ZM48.9043 60.8557L49.1039 59.8758L48.7569 59.8051L48.4428 59.9685L48.9043 60.8557ZM71.0866 59.9834L71.597 60.8434L73.4016 59.7724L71.433 59.0454L71.0866 59.9834ZM63 36C63 40.6659 61.8173 45.0525 59.7362 48.8796L61.4932 49.835C63.7298 45.7221 65 41.0079 65 36H63ZM36 9C50.9117 9 63 21.0883 63 36H65C65 19.9837 52.0163 7 36 7V9ZM9 36C9 21.0883 21.0883 9 36 9V7C19.9837 7 7 19.9837 7 36H9ZM36 63C21.0883 63 9 50.9117 9 36H7C7 52.0163 19.9837 65 36 65V63ZM48.4428 59.9685C44.7203 61.9051 40.4895 63 36 63V65C40.8184 65 45.365 63.8241 49.3658 61.7428L48.4428 59.9685ZM70.5762 59.1235C68.1713 60.5508 64.8126 61.1644 60.9859 61.1938C57.1795 61.2229 53.021 60.6739 49.1039 59.8758L48.7046 61.8355C52.7031 62.6503 57.0088 63.2243 61.0012 63.1937C64.9732 63.1633 68.7479 62.5344 71.597 60.8434L70.5762 59.1235ZM59.7088 49.7809C60.7713 52.0531 62.4433 54.425 64.3687 56.4234C66.2861 58.4134 68.5215 60.1022 70.7402 60.9215L71.433 59.0454C69.5999 58.3684 67.6096 56.9045 65.809 55.0357C64.0165 53.1752 62.4784 50.9822 61.5205 48.9337L59.7088 49.7809Z",
    fill: "#228B22"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8571,
    cy: 35.8571,
    r: 3.85714,
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0056,
    cy: 35.8571,
    r: 3.85714,
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.4275,
    cy: 35.8571,
    r: 3.85714,
    fill: "#228B22"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.c2ce313d.svg";
export { ForwardRef as ReactComponent };